export enum ProjectActiveStatus {
  Active = 'active',
  Archived = 'archived',
}

export enum ProjectLeadSource {
  Auction = 'auction',
  BanditSigns = 'bandit_signs',
  Billboards = 'billboards',
  ColdCalling = 'cold_calling',
  Craigslist = 'craigslist',
  DirectMail = 'direct_mail',
  DrivingForDollars = 'driving_for_dollars',
  FacebookMarketing = 'facebook_marketing',
  ForSaleByOwner = 'for_sale_by_owner',
  GoogleAdwords = 'google_adwords',
  ListingService = 'listing_service',
  MLS = 'mls',
  RadioAd = 'radio_ad',
  Referral = 'referral',
  RealEstateAgent = 'real_estate_agent',
  TvAd = 'tv_ad',
  Website = 'website',
  Wholesaler = 'wholesaler',
  Zillow = 'zillow',
  Other = 'other',
}

export enum ProjectInvestmentStrategy {
  BRRRR = 'brrrr',
  BuildToRent = 'build_to_rent',
  BuyAndHold = 'buy_and_hold',
  FixAndFlip = 'fix_and_flip',
  NewConstruction = 'new_construction',
  Rental = 'rental',
  ShortTermRental = 'short_term_rental',
  Wholesale = 'wholesale',
  Wholetail = 'wholetail',
  Other = 'other',
}

// See class constants on app/Project.php
export enum ProjectStage {
  Lead = 'lead',
  ContactingSeller = 'contacting_seller',
  AppointmentSet = 'appointment_set',
  OfferMade = 'offer_made',
  Negotiation = 'negotiation',
  PendingPurchase = 'pending_purchase',
  ConstructionOnHold = 'construction_on_hold',
  PlanningPermitting = 'planning_permitting',
  UnderConstruction = 'under_construction',
  PunchList = 'punch_list',
  ActiveListing = 'active_listing',
  PendingSale = 'pending_sale',
  CompletedPortfolio = 'completed_portfolio', // Completed/Sold
  RentalInventory = 'rental_inventory',
  WholesaleInventory = 'wholesale_inventory',
}

export type LeadStage =
  | ProjectStage.Lead
  | ProjectStage.ContactingSeller
  | ProjectStage.AppointmentSet
  | ProjectStage.OfferMade
  | ProjectStage.Negotiation
  | ProjectStage.PendingPurchase;

export type ActiveProjectStage =
  | ProjectStage.ConstructionOnHold
  | ProjectStage.PlanningPermitting
  | ProjectStage.UnderConstruction
  | ProjectStage.PunchList
  | ProjectStage.ActiveListing
  | ProjectStage.PendingSale;

export type PortfolioStage =
  | ProjectStage.CompletedPortfolio
  | ProjectStage.RentalInventory
  | ProjectStage.WholesaleInventory;
